<validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
<fieldset>
    <div class="row">
        <div class="col-sm-5 mvd_form-group">
            <label>Make</label>
            <Autocomplete #newMakeAC servicePath="vehicle/make/name" serviceIdPath="vehicle/make" value="id" text="makeDisplayValue" secondaryText="ncicCode" showItemNotFoundMessage="false" [disabled]="addingNewMake === false"></Autocomplete>
        </div>

        <div class="col-sm-6 mvd_form-group">
            <label>Model Name</label>
            <Autocomplete #newModelAC servicePath="vehicle/model/make/{parentId}/name" serviceIdPath="vehicle/model" value="id" text="modelValue" showItemNotFoundMessage="false"></Autocomplete>
        </div>
    </div>
    <button class="btn--primary" type="button" data-bs-dismiss="modal" (click)="addNewMake()" *ngIf="addingNewMake === true">Add this Make & Model</button>
    <button class="btn--primary" type="button" data-bs-dismiss="modal" (click)="addNewModel()" *ngIf="addingNewMake === false">Add this Model</button>
</fieldset>